import React from 'react'
import { Card, CardContent, Container, Typography } from '@material-ui/core'
import Page from '../Page'
import { FORM_ACTIONS } from 'src/utils/constants/general'
import ErrorsValidation from '../shared/displayErrorsValidations'
import FormAgrupador from './shared/form'
import PageContainer from 'src/containers/shared/PageContainer';

const EditAgrupador = (props) => {
  const {
    errors,
    loading,
    agrupador,
    updateAgrupador,
  } = props;

  return (
    <PageContainer title="Editar Agrupador" maxWidth={false}>
        <Typography
          color="textPrimary"
          variant="h2"
          className="mb-3"
        >
          Editando Agrupador
        </Typography>
        <ErrorsValidation errors={errors} />
        <Card>
          <CardContent>
            <FormAgrupador
              agrupador={agrupador}
              action={FORM_ACTIONS.EDIT}
              updateAgrupador={updateAgrupador}
              loading={loading}
            />
          </CardContent>
        </Card>
    </PageContainer>
  )
}

export default EditAgrupador
